import { createFileRoute } from '@tanstack/react-router';
import { ContestEditPrizesStep } from '../pages/contests/edit/contest-edit-prizes-step';

export const Route = createFileRoute('/contests/$id/edit/prizes')({
  component: ContestEditPrizesStep,
});
